import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { CampaignBannerContentBlockWrapper } from './ContentBlocks/CampaignBannerContentBlockWrapper'
import { CategoryBrandingContentBlockWrapper } from './ContentBlocks/CategoryBrandingContentBlockWrapper'
import { CategoryGridContentBlockWrapper } from './ContentBlocks/CategoryGridContentBlockWrapper'
import { CompactCampaignBannerContentBlockWrapper } from './ContentBlocks/CompactCampaignBannerContentBlockWrapper'
import { GradientInfoHeaderContentBlockWrapper } from './ContentBlocks/GradientInfoHeaderContentBlockWrapper'
import { NotificationContentBlockWrapper } from './ContentBlocks/NotificationContentBlockWrapper'
import { SimpleHeaderContentBlockWrapper } from './ContentBlocks/SimpleHeaderContentBlockWrapper'
import { SimpleTitleContentBlockWrapper } from './ContentBlocks/SimpleTitleContentBlockWrapper'
import { WaveLinkHeaderContentBlockWrapper } from './ContentBlocks/WaveLinkHeaderContentBlockWrapper'
// TODO: fix library UI component positioning and remove these legacy boxes once we've fully migrated to UX land-on-menu
import { LegacyCampaignHeaderBox, LegacyHeaderBox } from './LegacyHeaderBoxes'

const renderContentBlock = (contentBlock: MenuContentBlock) => {
  switch (contentBlock.type) {
    case 'category-grid':
      return <CategoryGridContentBlockWrapper contentBlock={contentBlock} />
    case 'simple-header':
      return <SimpleHeaderContentBlockWrapper contentBlock={contentBlock} />
    case 'simple-title':
      return <SimpleTitleContentBlockWrapper contentBlock={contentBlock} />
    case 'recipe-grid':
      return null
    case 'campaign-banner':
      return (
        <LegacyCampaignHeaderBox>
          <CampaignBannerContentBlockWrapper contentBlock={contentBlock} />
        </LegacyCampaignHeaderBox>
      )
    case 'compact-campaign-banner':
      return (
        <LegacyCampaignHeaderBox>
          <CompactCampaignBannerContentBlockWrapper contentBlock={contentBlock} />
        </LegacyCampaignHeaderBox>
      )
    case 'category-branding':
      return <CategoryBrandingContentBlockWrapper contentBlock={contentBlock} />
    case 'wave-link-header':
      return (
        <LegacyHeaderBox>
          <WaveLinkHeaderContentBlockWrapper contentBlock={contentBlock} />
        </LegacyHeaderBox>
      )
    case 'gradient-info-header':
      return (
        <LegacyHeaderBox>
          <GradientInfoHeaderContentBlockWrapper contentBlock={contentBlock} />
        </LegacyHeaderBox>
      )
    case 'notification':
      return <NotificationContentBlockWrapper contentBlock={contentBlock} />
    default:
      return null
  }
}

export const renderContentBlocks = (contentBlocks: MenuContentBlock[]) =>
  contentBlocks.map((contentBlock, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={`${contentBlock.type}-${index}`}>
      {renderContentBlock(contentBlock)}
    </React.Fragment>
  ))
